import React, { Component } from 'react'
import TeamMemberRow from './team_member_row'

class TeamMemberList extends Component {
    render() {
        const { teamMembers, reportUser, canEditMembership, handleDisableMember, profile, updateMemberRole, teamOwnerId } = this.props
        return (
            <div className="team-member-list">
                {teamMembers.sort( (a,b) => a.accessLevel === b.accessLevel ? 0 :  a.accessLevel > b.accessLevel ? 1 : -1)
                    .filter(tm => tm.isActive)
                    .map((tm)=>
                        <TeamMemberRow 
                            key={tm.id}
                            teamMember={tm}
                            reportUser={reportUser}
                            canViewReport={canEditMembership || profile.id === tm.id }
                            canEditMembership={canEditMembership}
                            canRemoveMembership={canEditMembership && tm.id !== profile.id && tm.id !== teamOwnerId}
                            onDisable={handleDisableMember}
                            isInvitedMember={false}
                            isTeamOwner={tm.id === teamOwnerId}
                            isCurrentUser={tm.id === profile.id}
                            updateMemberRole={updateMemberRole}
                        />)}
            </div>
        )
    }

}

export default TeamMemberList


// WEBPACK FOOTER //
// ./src/components/team_member_list.jsx